import moment from "moment";
import { formatearFecha } from "../../../../helpers/formato";

// Reglas para mover la fecha de una cuota, aparte para poder probarlas. El servidor aplica la
// misma regla con la fecha ya corrida al día hábil, que es la que manda.

/** Cuotas vecinas de `cuota` en el plan (por número), o null si no hay. */
export const vecinas = (cuota, plan = []) => ({
  anterior: plan.find((c) => c.numeroCuota === cuota.numeroCuota - 1) || null,
  siguiente: plan.find((c) => c.numeroCuota === cuota.numeroCuota + 1) || null,
});

/** Texto del rango permitido: no antes de la cuota anterior ni después de la siguiente. */
export const textoRango = ({ anterior, siguiente }) => {
  const f = (c) => `el ${formatearFecha(c.fechaPago)} (cuota ${c.numeroCuota})`;
  if (anterior && siguiente) return `Entre ${f(anterior)} y ${f(siguiente)}`;
  if (anterior) return `Desde ${f(anterior)}`;
  if (siguiente) return `Hasta ${f(siguiente)}`;
  return "";
};

/** Mensaje de error, o "" si la fecha se puede enviar. El mismo día que una vecina se permite. */
export const validarFechaCuota = (fecha, { anterior, siguiente }) => {
  const m = moment(fecha);
  if (!fecha || !m.isValid()) return "Elija una fecha válida";
  if (anterior && m.isBefore(moment(anterior.fechaPago), "day")) {
    return `No puede quedar antes de la cuota ${anterior.numeroCuota} (${formatearFecha(anterior.fechaPago)})`;
  }
  if (siguiente && m.isAfter(moment(siguiente.fechaPago), "day")) {
    return `No puede quedar después de la cuota ${siguiente.numeroCuota} (${formatearFecha(siguiente.fechaPago)})`;
  }
  return "";
};

/** Aviso al guardar (mismo verbo que el botón "Cambiar fecha") con la fecha que quedó; dice si el
 * servidor la corrió al día hábil. */
export const mensajeFechaGuardada = (numeroCuota, elegida, guardada) => {
  const base = `Fecha cambiada: la cuota ${numeroCuota} queda el ${formatearFecha(guardada)}`;
  return moment(guardada).isSame(moment(elegida), "day")
    ? base
    : `${base} (el ${formatearFecha(elegida)} no es día hábil)`;
};
